import { renderHours } from "../../scenes/time-tracking/worktime";

const HourLabel = ({ minutes }) => {
  return renderHours(minutes) + " h";
};

export default HourLabel;
